module.exports = __webpack_public_path__ + "img/img-shipin-s8.725b1dd5.png";